@if (regionsQueryResults$ | async; as result) {
<kendo-label text="Region">
    <kendo-multiselect [data]="result.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       textField="region"
                       valueField="region"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
}
